<rask-map-tab-widget (open)="onOpen($event)" [startTab]="'search'">
    <rask-map-widget-tab
        [id]="tabIds.search"
        [icon]="'far fa-search'"
        [index]="0"
        [open]="true"
        [tooltip]="'TPL_TOOLTIP_SOK' | translate">
        <rask-tpl-search></rask-tpl-search>
    </rask-map-widget-tab>

    <rask-map-widget-tab
        [id]="tabIds.filter"
        [icon]="'far fa-filter'"
        [index]="1"
        [tooltip]="'TPL_TOOLTIP_FILTRERA' | translate"
        [disabled]="!hasSearchResult()">
        <rask-tpl-filter></rask-tpl-filter>
    </rask-map-widget-tab>

    <rask-map-widget-tab
        [id]="tabIds.transporttilldelning"
        [icon]="'far fa-truck'"
        [index]="3"
        [tooltip]="'TPL_TOOLTIP_TRANSPORTTILLDELA' | translate"
        [disabled]="!hasSearchResult()">
        <rask-tpl-transporttilldelning [canEdit]="canEdit()"></rask-tpl-transporttilldelning>
    </rask-map-widget-tab>

    <rask-map-widget-tab
        [id]="tabIds.omdestinera"
        [icon]="'far fa-industry'"
        [index]="4"
        [tooltip]="'TPL_TOOLTIP_DESTINERA' | translate"
        [disabled]="!hasSearchResult()">
        <rask-tpl-omdestinera [canEdit]="canEdit()"></rask-tpl-omdestinera>
    </rask-map-widget-tab>

    <rask-map-widget-tab
        [id]="tabIds.hanteraao"
        [icon]="'far fa-sync'"
        [index]="6"
        [tooltip]="'TPL_TOOLTIP_HANTERAARBETSORDRAR' | translate"
        [disabled]="!hasSearchResult()">
        <rask-tpl-hantera-ao [canEdit]="canEdit()"></rask-tpl-hantera-ao>
    </rask-map-widget-tab>

    <rask-map-widget-tab
        [id]="tabIds.handelser"
        [icon]="'far fa-info-circle'"
        [index]="5"
        [counter]="dirtyHandelser"
        [tooltip]="'TPL_TOOLTIP_HANDELSER' | translate">
        <rask-tpl-handelser (dirtychanged)="dirtychanged($event)"></rask-tpl-handelser>
    </rask-map-widget-tab>

</rask-map-tab-widget>

<rask-tpl-karta></rask-tpl-karta>
<rask-footer></rask-footer>